var map = {
	"./avatar-ai.png": "29f0",
	"./avatar-assistant.png": "32cc",
	"./bg-large.svg": "7ad8",
	"./bg-small.svg": "01d3",
	"./grid-left-large.svg": "640a",
	"./grid-left-small.svg": "ef57",
	"./grid-right-large.svg": "df70",
	"./grid-right-small.svg": "58dd",
	"./speaker-left-bg.png": "8603",
	"./speaker-right-bg.png": "f6c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4420";